import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const InsuranceAndLiabilityPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  insuranceContact,
  legalContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Insurance_and_Liability_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Insurance & Liability Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        This policy outlines {clientName || "the Company’s"} approach to insurance coverage and liability management to protect the business, employees, clients, and stakeholders from risks associated with transport operations.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all vehicles, equipment, employees, and business activities undertaken by {clientName || "the Company"}.
      </p>

      <h4 className="section-title">3. Insurance Coverage</h4>
      <ul>
        <li><strong>Motor Insurance:</strong> Comprehensive cover for all company vehicles including third party, fire, theft, and damage.</li>
        <li><strong>Public Liability Insurance:</strong> Protection against claims for injury or damage to third parties arising from company operations.</li>
        <li><strong>Employers’ Liability Insurance:</strong> Coverage for employee injury or illness sustained in the course of employment, complying with statutory requirements.</li>
        <li><strong>Goods in Transit Insurance:</strong> Cover for goods carried by the company against loss or damage.</li>
        <li><strong>Professional Indemnity Insurance:</strong> Protection against claims of professional negligence where applicable.</li>
      </ul>

      <h4 className="section-title">4. Responsibilities</h4>
      <p className="section-content"><strong>Management:</strong> Ensure that all necessary insurance policies are maintained and renewed promptly.</p>
      <p className="policy-details"><strong>Insurance Coordinator Contact:</strong> {insuranceContact || "[Insert Contact Number]"}</p>
      <p className="policy-content"><strong>Employees:</strong> Must comply with policy requirements and report any incidents or accidents promptly.</p>
      <p className="policy-details"><strong>Legal Advisor Contact:</strong> {legalContact || "[Insert Contact Number]"}</p>

      <h4 className="section-title">5. Claims Procedure</h4>
      <ul>
        <li>All incidents, accidents, or losses must be reported immediately to the designated insurance coordinator.</li>
        <li>Accurate records and evidence should be collected to support any claim.</li>
        <li>Cooperate fully with insurers during investigations and follow their guidance.</li>
      </ul>

      <h4 className="section-title">6. Liability</h4>
      <p className="section-content">
        {clientName || "The Company"} accepts responsibility for its actions within the scope of its business operations but reserves the right to limit liability as detailed in contracts and agreements.
      </p>
      <p className="section-content">
        Employees must not admit liability or settle claims without prior authorisation from senior management or legal advisors.
      </p>

      <h4 className="section-title">7. Policy Review</h4>
      <p className="section-content">
        This policy will be reviewed annually or following any significant incident or legislative change.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I acknowledge that I have read, understood, and agree to comply with the Insurance & Liability Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default InsuranceAndLiabilityPolicy;
